import { create as l } from "zustand";
import f from "dayjs";
const y = {
  appName: "HCA Application",
  appPath: "/"
}, g = l((t, r) => ({
  ...y,
  get: (e) => r()[e],
  set: (e, o) => {
    t(typeof e == "string" ? (n) => ({ ...n, [e]: o }) : (n) => ({ ...n, ...e }));
  },
  remove: (e) => {
    t((o) => {
      const n = { ...o };
      return delete n[e], n;
    });
  },
  clear: () => {
    t(() => ({
      get: r().get,
      set: r().set,
      remove: r().remove,
      clear: r().clear,
      reset: r().reset,
      getAll: r().getAll
    }));
  },
  reset: () => {
    t((e) => ({
      ...y,
      get: e.get,
      set: e.set,
      remove: e.remove,
      clear: e.clear,
      reset: e.reset,
      getAll: e.getAll
    }));
  },
  getAll: () => {
    const e = r(), {
      get: o,
      set: n,
      remove: s,
      clear: i,
      reset: a,
      getAll: c,
      ...u
    } = e;
    return u;
  }
})), T = l((t, r) => ({
  tabsByScope: {},
  activeTabByScope: {},
  activeSubTabByParent: {},
  activeRecordByScope: {},
  addOpenTab: (e, o, n) => {
    const s = String(o), { tabsByScope: i } = r(), a = i[e] || [];
    a.some((c) => c.id === s) || t({
      tabsByScope: {
        ...i,
        [e]: [...a, { id: s, label: n }]
      }
    });
  },
  setTabLabel: (e, o, n) => {
    const s = String(o), { tabsByScope: i } = r(), a = i[e] || [];
    a.some((c) => c.id === s) && t({
      tabsByScope: {
        ...i,
        [e]: a.map(
          (c) => c.id === s ? { ...c, label: n } : c
        )
      }
    });
  },
  removeOpenTab: (e, o) => {
    const n = String(o), { tabsByScope: s, activeTabByScope: i } = r(), a = s[e] || [], c = i[e] === n ? null : i[e];
    t({
      tabsByScope: {
        ...s,
        [e]: a.filter((u) => u.id !== n)
      },
      activeTabByScope: {
        ...i,
        [e]: c
      }
    });
  },
  isTabOpen: (e, o) => {
    const n = String(o);
    return (r().tabsByScope[e] || []).some((i) => i.id === n);
  },
  getOpenTabs: (e) => r().tabsByScope[e] || [],
  setActiveTab: (e, o) => {
    const n = o === null ? null : String(o), { activeTabByScope: s } = r();
    t({
      activeTabByScope: {
        ...s,
        [e]: n
      }
    });
  },
  getActiveTab: (e) => r().activeTabByScope[e] ?? null,
  setActiveSubTab: (e, o) => {
    const { activeSubTabByParent: n } = r();
    t({
      activeSubTabByParent: {
        ...n,
        [e]: o
      }
    });
  },
  getActiveSubTab: (e) => r().activeSubTabByParent[e] ?? null,
  setActiveRecord: (e, o) => {
    const { activeRecordByScope: n } = r();
    t({
      activeRecordByScope: {
        ...n,
        [e]: o
      }
    });
  },
  getActiveRecord: (e) => r().activeRecordByScope[e] ?? null
})), _ = l((t, r) => ({
  filtersByScope: {},
  setFilters: (e, o) => {
    const { filtersByScope: n } = r();
    t({
      filtersByScope: {
        ...n,
        [e]: o
      }
    });
  },
  updateFilter: (e, o, n) => {
    const { filtersByScope: s } = r(), i = s[e] || {};
    t({
      filtersByScope: {
        ...s,
        [e]: { ...i, [o]: n }
      }
    });
  },
  getFilters: (e) => r().filtersByScope[e] ?? {},
  clearFilters: (e) => {
    const { filtersByScope: o } = r(), { [e]: n, ...s } = o;
    t({ filtersByScope: s });
  }
}));
function C(t) {
  return `${t.parentEntity ?? "_"}:${t.parentID ?? "_"}:${t.entity}:${t.formMode}:${t.formID ?? "new"}`;
}
function m(t, r, e) {
  return `:${t}:${r}:${e ?? "new"}`;
}
function b(t, r, e) {
  const o = { ...r }, n = { ...e };
  if (o[t])
    return delete o[t], { shouldSkip: !0, nextKeys: o, nextSuffixes: n };
  for (const s of Object.keys(n))
    if (t.endsWith(s))
      return delete n[s], { shouldSkip: !0, nextKeys: o, nextSuffixes: n };
  return { shouldSkip: !1, nextKeys: o, nextSuffixes: n };
}
const S = l((t, r) => ({
  draftsByKey: {},
  discardOnceKeys: {},
  discardOnceSuffixes: {},
  getDraft: (e) => r().draftsByKey[e],
  setDraft: (e, o) => {
    const { discardOnceKeys: n, discardOnceSuffixes: s, draftsByKey: i } = r(), a = b(
      e,
      n,
      s
    );
    if (a.shouldSkip) {
      t({
        discardOnceKeys: a.nextKeys,
        discardOnceSuffixes: a.nextSuffixes
      });
      return;
    }
    t({
      draftsByKey: {
        ...i,
        [e]: { ...o }
      }
    });
  },
  deleteDraft: (e) => {
    const { draftsByKey: o } = r();
    if (!(e in o)) return;
    const n = { ...o };
    delete n[e], t({ draftsByKey: n });
  },
  clearDraft: (e) => {
    const { draftsByKey: o, discardOnceKeys: n } = r(), s = { ...o };
    delete s[e], t({
      draftsByKey: s,
      discardOnceKeys: {
        ...n,
        [e]: !0
      }
    });
  },
  clearDraftsForRecord: (e, o, n) => {
    const s = m(e, o, n), { draftsByKey: i, discardOnceSuffixes: a } = r(), c = { ...i };
    for (const u of Object.keys(c))
      u.endsWith(s) && delete c[u];
    t({
      draftsByKey: c,
      discardOnceSuffixes: {
        ...a,
        [s]: !0
      }
    });
  }
}));
function O(t) {
  return S.getState().getDraft(t);
}
function A(t, r) {
  S.getState().setDraft(t, r);
}
function h(t) {
  S.getState().deleteDraft(t);
}
function E(t, r, e) {
  S.getState().clearDraftsForRecord(t, r, e);
}
const p = {
  definitions: null,
  isInitialized: !1,
  allReady: !1,
  pendingCount: 0,
  readyCount: 0,
  errorCount: 0
}, d = l((t, r) => ({
  ...p,
  initDefinitions: (e) => {
    const o = {};
    let n = 0;
    for (const [s, i] of Object.entries(e))
      o[s] = {
        ...i,
        render: null,
        renderStatus: "pending"
      }, n++;
    t({
      definitions: o,
      isInitialized: !0,
      allReady: !1,
      pendingCount: n,
      readyCount: 0,
      errorCount: 0
    });
  },
  setEntitySchema: (e, o) => {
    const { definitions: n, pendingCount: s, readyCount: i } = r();
    if (!(n != null && n[e])) return;
    const a = n[e].renderStatus === "pending";
    t({
      definitions: {
        ...n,
        [e]: {
          ...n[e],
          render: o,
          renderStatus: "ready",
          renderError: void 0
        }
      },
      pendingCount: a ? s - 1 : s,
      readyCount: a ? i + 1 : i
    });
  },
  setEntityError: (e, o) => {
    const { definitions: n, pendingCount: s, errorCount: i } = r();
    if (!(n != null && n[e])) return;
    const a = n[e].renderStatus === "pending";
    t({
      definitions: {
        ...n,
        [e]: {
          ...n[e],
          render: null,
          renderStatus: "error",
          renderError: o
        }
      },
      pendingCount: a ? s - 1 : s,
      errorCount: a ? i + 1 : i
    });
  },
  setAllComplete: () => {
    t({ allReady: !0 });
  },
  reset: () => {
    t(p);
  }
}));
function x(t) {
  var r;
  return ((r = t == null ? void 0 : t.ui) == null ? void 0 : r.openMode) === "read" ? "read" : "edit";
}
function K(t) {
  var r;
  return ((r = t == null ? void 0 : t.ui) == null ? void 0 : r.editable) !== !1;
}
function R(t, r) {
  return !r && t === "edit" ? "read" : t;
}
function F(t) {
  return t === "read" ? "read" : "edit";
}
function I() {
  const t = d((i) => i.definitions), r = d((i) => i.isInitialized), e = d((i) => i.allReady), o = d((i) => i.pendingCount), n = d((i) => i.readyCount), s = d((i) => i.errorCount);
  return {
    definitions: t,
    isInitialized: r,
    allReady: e,
    pendingCount: o,
    readyCount: n,
    errorCount: s
  };
}
function w(t) {
  return d((r) => {
    var e;
    return (e = r.definitions) == null ? void 0 : e[t];
  });
}
function M() {
  const t = d((s) => s.initDefinitions), r = d((s) => s.setEntitySchema), e = d((s) => s.setEntityError), o = d((s) => s.setAllComplete), n = d((s) => s.reset);
  return {
    initDefinitions: t,
    setEntitySchema: r,
    setEntityError: e,
    setAllComplete: o,
    reset: n
  };
}
function B(t, r, e, o) {
  if (t === "{{now}}")
    switch (r) {
      case "date":
        return f().format("YYYY-MM-DD");
      case "timestamp":
        return f().toISOString();
      case "time":
        return f().format("HH:mm");
      default:
        return f().toISOString();
    }
  if (t === "{{last_month}}") {
    const n = f().subtract(1, "month").endOf("month");
    switch (r) {
      case "timestamp":
        return n.toISOString();
      case "time":
        return n.format("HH:mm");
      default:
        return n.format("YYYY-MM-DD");
    }
  }
  if (t === "{{user.role}}") {
    if (o) {
      for (const n of Object.values(o))
        if (n.type === "relation" && n.target === "user")
          return;
    }
    return e ? e.is_super_admin ? "admin" : "user" : void 0;
  }
}
function Y(t, r, e) {
  var n, s;
  const o = {};
  for (const [i, a] of Object.entries(t)) {
    if (e && !e.has(i)) continue;
    const c = (n = a.ui) == null ? void 0 : n.template;
    if (!c)
      ((s = a.ui) == null ? void 0 : s.default) !== void 0 && (o[i] = a.ui.default);
    else {
      const u = B(
        c,
        a.type,
        r,
        t
      );
      u !== void 0 && (o[i] = u);
    }
  }
  return o;
}
export {
  F as a,
  I as b,
  w as c,
  M as d,
  Y as e,
  g as f,
  x as g,
  T as h,
  K as i,
  E as j,
  _ as k,
  C as l,
  S as m,
  O as n,
  h as o,
  R as r,
  A as s,
  d as u
};
